module.exports = __webpack_public_path__ + "static/media/What is Cascading.1a8cbbbf.png";